/* =============================================================
   DPM Nederland — Shopify redesign, kleine DOM-verrijkingen
   Thema: Warehouse 5.1.0

   Plaatsen: assets/dpm-redesign.js + in layout/theme.liquid vlak voor </body>:
     <script src="{{ 'dpm-redesign.js' | asset_url }}" defer></script>

   Let op: de topbalk, USP-strip en footer-linkkolom zijn hier in JS
   opgebouwd zodat de opzet snel te beoordelen is. Voor productie horen
   die drie beter thuis als echte Liquid-secties/blokken, zodat de klant
   ze in de theme editor kan beheren. Zie de notities onderaan.
   ============================================================= */
(function () {
  'use strict';

  var ICON = {
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="m5 13 4 4L19 7"/></svg>',
    arrow: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>',
    chevron: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>'
  };

  /* --- 1 & 2. Topbalk en USP-strip: VERVALLEN --------------------------
     Die werden hier in de browser opgebouwd met hardcoded teksten. Ze zijn
     vervangen door echte secties, zodat de klant ze in de theme-editor kan
     beheren:
       sections/dp-topbar.liquid   -> tagline, e-mail, telefoon
       sections/dp-usp.liquid      -> 3 USP-blokken, uitbreidbaar tot 4
     Beide toevoegen via Customize -> Header-groep -> Sectie toevoegen.
     De opmaak (.dp-topbar / .dp-usp) staat gewoon in dpm-redesign.css.    */

  /* --- 3. Header + nav sticky, krimpt bij scrollen --------------------- */
  function stickyHeader() {
    var nav = document.querySelector('.nav-bar');
    var section = nav && nav.closest('[id^="shopify-section"]');
    if (section) section.classList.add('dp-sticky');

    var onScroll = function () {
      document.body.classList.toggle('dp-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- 4. "Bekijk alles" naast elke sectietitel ------------------------ */
  function sectionLinks() {
    [].forEach.call(document.querySelectorAll('.section__header'), function (h) {
      if (h.querySelector('.dp-section-link')) return;
      var a = document.createElement('a');
      a.className = 'dp-section-link';
      a.href = h.closest('[id^="shopify-section"]').dataset.dpCollection || '/collections/all';
      a.innerHTML = 'Bekijk alles ' + ICON.arrow;
      h.appendChild(a);
    });
  }

  /* --- 5. Productkaart omzetten ----------------------------------------
     Eindvorm: cover groot, titel, en onderin één regel met de prijs links
     en een compacte icoonknop rechts. Uitverkocht wordt een klein label
     rechtsboven in plaats van een grijze knop over de volle breedte.

     Twee dingen om niet te verprutsen bij een herbouw in Liquid:
     - de knop MOET binnen het <form> blijven, anders werkt toevoegen aan
       de winkelwagen niet. Daarom verhuist het hele formulier mee.
     - "Snel bekijken" heet per template anders (--list-view-only op de
       homepage, --ternary op de collectiepagina).                        */
  function productCards() {
    var icon = document.querySelector('.header__action-item--cart svg');
    var CART = icon ? icon.outerHTML :
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
      '<path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>';

    [].forEach.call(document.querySelectorAll('.product-item'), function (item) {
      if (item.dataset.dpCard) return;
      item.dataset.dpCard = '1';

      // producten zonder cover lieten de kaart inklappen -> ruimte reserveren
      if (!item.querySelector('.product-item__image-wrapper') && !item.querySelector('.dp-noimg')) {
        var ph = document.createElement('div');
        ph.className = 'dp-noimg';
        ph.setAttribute('aria-hidden', 'true');
        item.insertBefore(ph, item.firstChild);
      }

      var info = item.querySelector('.product-item__info');
      var price = item.querySelector('.product-item__price-list');
      var form = item.querySelector('.product-item__action-list');
      var buttons = [].slice.call(item.querySelectorAll('.product-item__action-button'));
      var quick = buttons.filter(function (b) {
        return b.classList.contains('product-item__action-button--list-view-only') ||
               b.classList.contains('button--ternary');
      });
      var add = buttons.filter(function (b) { return quick.indexOf(b) === -1; })[0];

      quick.forEach(function (b) { b.remove(); });

      var soldOut = !!add && (add.disabled || /uitverkocht/i.test(add.textContent));

      if (soldOut) {
        var badge = document.createElement('span');
        badge.className = 'dp-badge';
        badge.textContent = 'Tijdelijk uitverkocht';
        item.insertBefore(badge, item.firstChild);
      }

      var foot = document.createElement('div');
      foot.className = 'dp-cardfoot';
      if (price) foot.appendChild(price);
      if (form) foot.appendChild(form);
      if (info) info.appendChild(foot);

      if (add) {
        if (soldOut) {
          add.remove();                       // label vervangt de knop
        } else {
          add.classList.add('dp-cart-btn');
          add.setAttribute('aria-label', 'In winkelwagen');
          add.title = 'In winkelwagen';
          add.innerHTML = CART + '<span class="visually-hidden">In winkelwagen</span>';
        }
      }
    });
  }

  /* --- 5b. Productlijsten in de gaten houden ---------------------------
     De collectiepagina bouwt kaarten opnieuw op bij filteren, sorteren en
     doorbladeren. Een script dat alleen op DOMContentLoaded/load draait,
     mist die kaarten: live gemeten 24 van 25 verwerkt, waarbij de kaart
     die er later bij kwam zijn label en icoonknop miste.

     De observer wordt tijdens het verwerken losgekoppeld, want
     productCards() verplaatst zelf nodes en zou zichzelf anders opnieuw
     aanroepen.

     Er wordt bewust op document.body geobserveerd en niet op de losse
     productlijsten. Reden: de carrousel onderaan de collectiepagina wordt
     door Flickity pas na dit script opgebouwd, dus die lijst bestaat nog
     niet als je hier de doelen vastlegt. Live gemeten: met losse lijsten
     bleef 1 van de 25 kaarten onbehandeld, met body 25 van 25.            */
  function watchProductLists() {
    if (window.__dpCardObserver) return;

    var pending = false;
    var observe = function () {
      window.__dpCardObserver.observe(document.body, { childList: true, subtree: true });
    };

    window.__dpCardObserver = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        window.__dpCardObserver.disconnect();   // productCards() verplaatst zelf
        productCards();                         // nodes en zou zichzelf anders
        observe();                              // opnieuw aanroepen
        pending = false;
      });
    });

    observe();
  }

  /* --- 6. Hero-CTA op slides zonder eigen knop ------------------------- */
  function heroCta() {
    [].forEach.call(document.querySelectorAll('.slideshow__slide'), function (slide) {
      if (slide.querySelector('.slideshow__button') || slide.querySelector('.dp-hero-cta')) return;
      var box = slide.querySelector('.slideshow__content-wrapper .container');
      if (!box) return;
      var a = document.createElement('a');
      a.className = 'dp-hero-cta';
      a.href = '/collections/all';
      a.innerHTML = 'Bekijk het aanbod ' + ICON.arrow;
      box.appendChild(a);
    });
  }

  /* --- 7. Lange productomschrijving inklappen -------------------------- */
  function clampDescription() {
    var scope = document.querySelector('.featured-product') || document.querySelector('.product-block-list');
    if (!scope) return;
    var rtes = [].slice.call(scope.querySelectorAll('.rte')).sort(function (a, b) {
      return b.textContent.length - a.textContent.length;
    });
    var rte = rtes[0];
    if (!rte || rte.dataset.dpClamped || rte.scrollHeight <= 240) return;

    rte.dataset.dpClamped = '1';
    rte.classList.add('dp-desc-clip');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dp-desc-toggle';
    btn.innerHTML = 'Lees de volledige beschrijving ' + ICON.chevron;
    btn.addEventListener('click', function () {
      var collapsed = rte.classList.toggle('dp-desc-clip');
      btn.firstChild.textContent = collapsed ? 'Lees de volledige beschrijving ' : 'Toon minder ';
      btn.querySelector('svg').style.transform = collapsed ? '' : 'rotate(180deg)';
    });
    rte.parentNode.insertBefore(btn, rte.nextSibling);
  }

  /* --- 7b. Galerij met één foto herkennen ------------------------------
     De thumbnailstrip is zinloos bij één afbeelding en kost ruimte.
     De CSS pakt .dp-single-image op. In het thema hoort dit uiteindelijk
     in de Liquid: {% if product.media.size > 1 %} rond de thumbnails.    */
  function singleImageGallery() {
    [].forEach.call(document.querySelectorAll('.product-gallery'), function (g) {
      if (g.querySelectorAll('.product-gallery__carousel-item').length <= 1) {
        g.classList.add('dp-single-image');
      }
    });
  }

  /* --- 7c. Form splitsen in tekstkolom + koopblok ----------------------
     Warehouse stopt titel, omschrijving, prijs en knoppen allemaal in één
     <form class="product-form">. Voor de drie-koloms opzet worden die in
     twee wrappers verdeeld; de form zelf wordt het grid.

     De hidden inputs MOETEN directe kinderen van de form blijven, anders
     breekt het toevoegen aan de winkelwagen.

     In het thema hoort dit uiteindelijk in de Liquid van de sectie, niet
     in JS — dit is de snelle route om de indeling te kunnen beoordelen.   */
  function splitProductForm() {
    // Ook de echte productpagina, niet alleen het uitgelichte blok op de
    // homepage. Daar stonden de knoppen nog 536px breed — precies het
    // probleem dat we op de homepage hadden opgelost.
    var form = document.querySelector('.featured-product .product-form') ||
               document.querySelector('.product-form');
    if (!form || form.dataset.dpSplit) return;
    form.dataset.dpSplit = '1';

    // Op de productpagina is de galerij de hoofdafbeelding en staat die in
    // een eigen kolom; die laten we met rust. Alleen in het uitgelichte
    // blok verhuist de cover mee naar het koopblok.
    var isFeatured = !!form.closest('.featured-product');

    var main = document.createElement('div');
    var buy = document.createElement('div');
    main.className = 'dp-pd-main';
    buy.className = 'dp-pd-buy';

    // Deelknoppen bewust NIET hierin: die horen bij de tekst, niet bij de
    // koopactie. De variantkiezer wél — die staat alleen op de productpagina
    // en hoort bij de aankoopbeslissing.
    var BUY_PARTS = '.product-form__variants,.product-form__info-list,.product-form__buy-buttons,.dp-trust';

    [].slice.call(form.children).forEach(function (child) {
      if (child.tagName === 'INPUT') return;              // hidden inputs blijven staan
      (child.matches(BUY_PARTS) ? buy : main).appendChild(child);
    });

    form.appendChild(main);
    form.appendChild(buy);

    // Cover bovenin het koopblok, bij de prijs — ALLEEN in het uitgelichte
    // blok op de homepage. Op de productpagina is de galerij de
    // hoofdafbeelding in een eigen kolom en moet die daar blijven.
    if (isFeatured) {
      var fp = form.closest('.featured-product');
      var gallery = fp && fp.querySelector('.product-gallery');
      if (gallery && !buy.contains(gallery)) {
        buy.insertBefore(gallery, buy.firstChild);
        if (fp.children[0]) fp.children[0].classList.add('dp-empty-card');
      }
    }

    // Deelknoppen horen bij de tekst, niet bij de koopactie — en onderaan,
    // niet tussen de uitgever en de omschrijving in. Ze zitten in
    // .product-meta en liften anders vanzelf naar boven mee.
    var share = form.querySelector('.product-meta__share-buttons');
    if (share) {
      share.classList.remove('hidden-tablet-and-up');
      main.appendChild(share);
    }
  }

  /* --- 8. Vertrouwensblok onder de koopknoppen -------------------------
     Alleen feitelijke informatie die al op de site staat.                */
  function trustBlock() {
    var pc = document.querySelector('.product-form__payment-container');
    if (!pc || document.querySelector('.dp-trust')) return;

    // Telefoonnummer uit de topbalk-sectie halen i.p.v. hier hardcoden.
    // Anders staat hetzelfde nummer op twee plekken en loopt het uit de pas
    // zodra de klant het in de theme-editor wijzigt.
    var telLink = document.querySelector('.dp-topbar__item[data-dp-phone] span');
    var tel = telLink ? telLink.textContent.trim() : '';
    var contact = tel ? 'Bel ' + tel + ' — ma t/m vr 09:00–13:00 uur'
                      : 'Neem gerust contact met ons op';

    // [kop, toelichting] — kop op regel 1, toelichting op regel 2
    var rows = [
      ['Veilig betalen', 'iDEAL, creditcard en Shop Pay'],
      ['Persoonlijk contact', contact],
      ['Jouw aankoop steunt DPM', 'Het Bijbelonderwijs van Derek Prince in Nederland']
    ];
    var box = document.createElement('div');
    box.className = 'dp-trust';
    box.innerHTML = rows.map(function (r) {
      return '<div class="dp-trust__row">' +
        '<span class="dp-trust__ico">' + ICON.check + '</span>' +
        '<span class="dp-trust__txt"><b>' + r[0] + '</b><span>' + r[1] + '</span></span>' +
        '</div>';
    }).join('');
    pc.parentNode.insertBefore(box, pc.nextSibling);
  }

  /* --- 8b. Placeholder voor de lege blog-band --------------------------
     TODO klant: echte introtekst aanleveren, dan mag deze functie weg.   */
  function blogPlaceholder() {
    var d = document.querySelector('.page__description');
    if (!d || d.dataset.dpDummy || d.textContent.replace(/[\s.-]/g, '').length > 3) return;
    d.dataset.dpDummy = '1';
    d.innerHTML = '<p><em>[voorbeeldtekst — nog aan te leveren]</em><br>' +
      'Elke week een korte overdenking uit het Bijbelonderwijs van Derek Prince. ' +
      'Een paar minuten lezen die je helpen om de dag met een open Bijbel te beginnen.</p>';
  }

  /* --- 9. Mosaic platslaan tot één gelijkmatig grid --------------------- */
  function flattenMosaic() {
    var mosaic = document.querySelector('.mosaic');
    if (!mosaic || mosaic.dataset.dpFlat) return;
    mosaic.dataset.dpFlat = '1';

    [].forEach.call(mosaic.querySelectorAll('.promo-block'), function (block) {
      var cell = document.createElement('div');
      cell.className = 'dp-mosaic-cell';
      cell.appendChild(block);
      mosaic.appendChild(cell);
    });
    [].forEach.call(mosaic.querySelectorAll('.mosaic__column'), function (col) { col.remove(); });
  }

  /* --- 10. Extra footerkolom met snelle links -------------------------- */
  function footerLinks() {
    var newsletter = document.querySelector('.footer__block-item--newsletter');
    if (!newsletter || document.querySelector('.dp-footer-links')) return;

    var links = [].map.call(document.querySelectorAll('.nav-bar__item'), function (li) {
      var a = li.querySelector('a');
      return a ? { text: a.textContent.trim(), href: a.getAttribute('href') || '#' } : null;
    }).filter(Boolean);

    links.push({ text: 'Algemene voorwaarden', href: '/policies/terms-of-service' });
    links.push({ text: 'Privacybeleid', href: '/policies/privacy-policy' });

    var col = document.createElement('div');
    col.className = 'footer__block-item dp-footer-links';
    col.innerHTML = '<p class="footer__title">Snel naar</p><ul class="dp-flist">' +
      links.map(function (l) { return '<li><a href="' + l.href + '">' + l.text + '</a></li>'; }).join('') +
      '</ul>';
    newsletter.parentNode.insertBefore(col, newsletter);
  }

  function init() {
    // topbar() en uspStrip() vervallen: nu Liquid-secties, zie blok 1 & 2
    stickyHeader();
    sectionLinks();
    productCards();
    watchProductLists();
    heroCta();
    singleImageGallery();
    clampDescription();
    trustBlock();
    splitProductForm();   // NA trustBlock: het vertrouwensblok moet mee naar het koopblok
    blogPlaceholder();
    flattenMosaic();
    footerLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Warehouse herlaadt secties live in de theme editor
  document.addEventListener('shopify:section:load', init);

  // Nog een keer na window.load: het thema initialiseert Flickity soms later
  // en dan bestaan sommige elementen bij DOMContentLoaded nog niet. Alle
  // functies hierboven zijn idempotent (guards op dataset/class), dus een
  // tweede ronde kan geen dubbele elementen opleveren.
  window.addEventListener('load', init);
})();

/* -------------------------------------------------------------------
   Notities voor de definitieve uitwerking in het thema
   -------------------------------------------------------------------
   1. Topbalk en USP-strip horen echte secties te worden
      (sections/dp-topbar.liquid en sections/dp-usp.liquid) met schema-
      instellingen, zodat de klant tekst en iconen zelf kan aanpassen.
   2. De footer-linkkolom kan gewoon een extra "Menu"-blok in de
      bestaande footersectie zijn — dan is de JS daarvoor niet nodig.
   3. Het productgrid: zet in de theme editor bij de sectie
      "Uitgelichte collectie" de slider-weergave uit. Dan is het
      neutraliseren van Flickity in de CSS overbodig.
   4. Voorraadstatus hoort in snippets/product-item.liquid, op basis van
      product.available / variant.inventory_quantity in plaats van door
      de knoptekst te lezen.
   ------------------------------------------------------------------- */
